<!--
 * @Description: 今日异动
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-23 11:07:01
 * @LastEditTime: 2022-08-23 13:32:49
-->
<template>
<div class="statisticalChartsContainer">
  <!-- 今日异动 -->
  <!-- <div id="lottie" ref='lottie'></div> -->
  <div class="chartItem">
    <!-- 报警 -->
    <div class="left-box">
      <div class="box-contain">
        <h4>
          <img src="../../assets/img/bigScreen/yd/alarm-light-top.png" alt="" class="light-top">
          <p class="num" :title="alarm">{{ alarm > 99999 ? '99999+' : alarm }}</p>
          <p class="num-text">报警</p>
          <p class="light-bottom"></p>
        </h4>
        <div class="di-tu"></div>         
        <ul class="di-item">
          <li
            v-for="({top, left, width, height, backgroundPosition}, i) in leftList"
            :key="i"
            :style="{ top, left, width, height, backgroundPosition }"
            :class="`li_${i}`"
            :title="i"
            ></li>
        </ul> 
        <img class="bottom" src="./../../assets/img/bigScreen/yd/bottom.png" alt="">
      </div>
    </div>
    <!-- 故障 -->
    <div class="right-box">
      <div class="box-contain">
        <h4>
          <img src="../../assets/img/bigScreen/yd/fault-light-top.png" alt="" class="light-top">
          <p class="num" :title="fault">{{ fault > 99999 ? '99999+' : fault }}</p>
          <p class="num-text">故障</p>
          <p class="light-bottom"></p>
        </h4>
        <div class="di-tu"></div>         
        <ul class="di-item">
          <li
            v-for="({top, left, width, height, backgroundPosition}, i) in rightList"
            :key="i"
            :style="{ top, left, width, height, backgroundPosition }"
            :class="`li_${i}`"
            :title="i"
            ></li>
        </ul>
        <img class="bottom" src="./../../assets/img/bigScreen/yd/bottom.png" alt="">      
      </div>
    </div>
  </div>
</div>
</template>

<script>
import lottie from 'lottie-web';

import data from "@/assets/json/data.json";
// import * as echarts from 'echarts'
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    var dataStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        shadowBlur: 0,
        shadowColor: '#203665'
      }
    };
    return {
      echartsList: [],
      alarm: 0,
      fault: 0,
      leftList: [
        { top: '30px', left: '10px', width: '18px', height: '8px', backgroundPosition: '-10px -80px' },
        { top: '36px', left: '11px', width: '18px', height: '10px', backgroundPosition: '-11px -97px' },
        { top: '42px', left: '14px', width: '18px', height: '12px', backgroundPosition: '-11px -114px' },
        { top: '48px', left: '20px', width: '19px', height: '13px', backgroundPosition: '-11px -132px' },
        { top: '53px', left: '30px', width: '19px', height: '15px', backgroundPosition: '-36px -78px' },
        { top: '56px', left: '44px', width: '18px', height: '14px', backgroundPosition: '-36px -95px' },
        { top: '58px', left: '61px', width: '16px', height: '13px', backgroundPosition: '-38px -114px' },
        { top: '57px', left: '76px', width: '18px', height: '13px', backgroundPosition: '-37px -132px' },
        { top: '53px', left: '89px', width: '19px', height: '14px', backgroundPosition: '-62px -78px' },
        { top: '48px', left: '99px', width: '21px', height: '13px', backgroundPosition: '-62px -96px' },
        { top: '42px', left: '106px', width: '19px', height: '12px', backgroundPosition: '-63px -114px' },
        { top: '36px', left: '110px', width: '18px', height: '10px', backgroundPosition: '-63px -133px' },
        { top: '30px', left: '111px', width: '18px', height: '8px', backgroundPosition: '-90px -80px' },
        { top: '23px', left: '107px', width: '18px', height: '8px', backgroundPosition: '-88px -99px' },
        { top: '18px', left: '103px', width: '17px', height: '9px', backgroundPosition: '-90px -117px' },
        { top: '13px', left: '95px', width: '15px', height: '8px', backgroundPosition: '-90px -134px' },
        { top: '10px', left: '87px', width: '14px', height: '8px', backgroundPosition: '-113px -81px' },
        { top: '7px', left: '78px', width: '14px', height: '9px', backgroundPosition: '-113.5px -99.3px' },
        { top: '6px', left: '68px', width: '15px', height: '9px', backgroundPosition: '-112.5px -116.9px' },
        { top: '6px', left: '58px', width: '12px', height: '8px', backgroundPosition: '-114px -135px' },
        { top: '8px', left: '47px', width: '15px', height: '10px', backgroundPosition: '-135px -82.5px' },
        { top: '10px', left: '37px', width: '14px', height: '8px', backgroundPosition: '-135.2px -99.5px' },
        { top: '13px', left: '28px', width: '17px', height: '10px', backgroundPosition: '-135px -117px' },
        { top: '18px', left: '20px', width: '17px', height: '10px', backgroundPosition: '-134px -135px' },
        { top: '23px', left: '15px', width: '18px', height: '10px', backgroundPosition: '-12px -152px' }
      ],
      rightList: [
        { top: '30px', left: '10px', width: '18px', height: '8px', backgroundPosition: '-10px -80px' },
        { top: '36px', left: '11px', width: '18px', height: '10px', backgroundPosition: '-11px -97px' },
        { top: '42px', left: '14px', width: '18px', height: '12px', backgroundPosition: '-11px -114px' },
        { top: '48px', left: '20px', width: '19px', height: '13px', backgroundPosition: '-11px -132px' },
        { top: '53px', left: '30px', width: '19px', height: '15px', backgroundPosition: '-36px -78px' },
        { top: '56px', left: '44px', width: '18px', height: '14px', backgroundPosition: '-36px -95px' },
        { top: '58px', left: '61px', width: '16px', height: '13px', backgroundPosition: '-38px -114px' },
        { top: '57px', left: '76px', width: '18px', height: '13px', backgroundPosition: '-37px -132px' },
        { top: '53px', left: '89px', width: '19px', height: '14px', backgroundPosition: '-62px -78px' },
        { top: '48px', left: '99px', width: '21px', height: '13px', backgroundPosition: '-62px -96px' },
        { top: '42px', left: '106px', width: '19px', height: '12px', backgroundPosition: '-63px -114px' },
        { top: '36px', left: '110px', width: '18px', height: '10px', backgroundPosition: '-63px -133px' },
        { top: '30px', left: '111px', width: '18px', height: '8px', backgroundPosition: '-90px -80px' },
        { top: '23px', left: '107px', width: '18px', height: '8px', backgroundPosition: '-88px -99px' },
        { top: '18px', left: '103px', width: '17px', height: '9px', backgroundPosition: '-90px -117px' },
        { top: '13px', left: '95px', width: '15px', height: '8px', backgroundPosition: '-90px -134px' },
        { top: '10px', left: '87px', width: '14px', height: '8px', backgroundPosition: '-113px -81px' },
        { top: '7px', left: '78px', width: '14px', height: '9px', backgroundPosition: '-113.5px -99.3px' },
        { top: '6px', left: '68px', width: '15px', height: '9px', backgroundPosition: '-112.5px -116.9px' },
        { top: '6px', left: '58px', width: '12px', height: '8px', backgroundPosition: '-114px -135px' },
        { top: '8px', left: '47px', width: '15px', height: '10px', backgroundPosition: '-135px -82.5px' },
        { top: '10px', left: '37px', width: '14px', height: '8px', backgroundPosition: '-135.2px -99.5px' },
        { top: '13px', left: '28px', width: '17px', height: '10px', backgroundPosition: '-135px -117px' },
        { top: '18px', left: '20px', width: '17px', height: '10px', backgroundPosition: '-134px -135px' },
        { top: '23px', left: '15px', width: '18px', height: '10px', backgroundPosition: '-12px -152px' }
      ]
    }
  },
  computed: {
    idName() {
      return this.flag ? "echartsId4_big" : "echartsId4"
    },
  },
  created() {
    // this.initStyle()
    this.getEchartsList();
  },
  mounted() {
    // this.initAnimate()
    // this.$nextTick(() => {
    //   console.log(data)
    //   let animat = lottie.loadAnimation({
    //     container: this.$refs.lottie, //渲染的容器
    //     renderer: 'svg',
    //     loop: true,
    //     autoplay: true,
    //     animationData: data
    //   });
    // })
  },
  methods: {
    initStyle() {
      this.options.series[0].radius = [...this.styleObj.series.radious]
      this.options.series[0].data[0].label.normal.rich.a.fontSize = this.styleObj.series.aSize
      this.options.series[0].data[0].label.normal.rich.b.fontSize = this.styleObj.series.bSize
      this.options.series[1].radius = [...this.styleObj.series.radious]
      this.options.series[1].data[0].label.normal.rich.a.fontSize = this.styleObj.series.aSize
      this.options.series[1].data[0].label.normal.rich.b.fontSize = this.styleObj.series.bSize
    },
    async getEchartsList() {//今日异动
      const { code, msg, data } = await this.request.post('/front/device/alarmAndFaultDayStatistics')
      if (code != 200) {
        // return this.$message.error(msg)
        return
      }
      let { alarmHandleCount, alarmTotalCount, faultHandleCount, faultTotalCount } = data
      // this.echartsList = data

      // 百分比计算方式1格=1%~4%；2格=5%~8%；；3格=9%~12%；...
      let temp = [
        [1, 4], [5, 8], [9, 12], [13, 16], [17, 20],
        [21, 24], [25, 28], [29, 32], [33, 36], [37, 40],
        [41, 44], [45, 48], [49, 52], [53, 56], [57, 60],
        [61, 64], [65, 68], [69, 72], [73, 76], [77, 80],
        [81, 84], [85, 88], [89, 92], [93, 96], [97, 100],
      ]

      // 报警数据解析
      let alarmRate = alarmTotalCount == 0 ? 0 : (alarmHandleCount /alarmTotalCount * 100)

      let alarmNum = 0

      if (alarmRate >= 100 || alarmRate <= 0) {
        alarmNum = alarmRate >= 100 ? 25 : 0
      } else {
        alarmNum = temp.findIndex(([a1, a2]) => (a1 <= alarmRate && alarmRate <= a2) )
        alarmNum != -1 && alarmNum++
      }

      let leftList = [ ...this.leftList ]
      this.leftList = alarmNum == 0 ? [] : leftList.slice(0, alarmNum)

      // 故障数据解析
      let faultRate = faultTotalCount == 0 ? 0 : (faultHandleCount /faultTotalCount * 100)

      let faultNum = 0

      if (faultRate >= 100 || faultRate <= 0) {
        faultNum = faultRate >= 100 ? 25 : 0
      } else {
        faultNum = temp.findIndex(([a1, a2]) => (a1 <= faultRate && faultRate <= a2) )
        faultNum != -1 && faultNum++
      }

      let rightList = [ ...this.rightList ]
      this.rightList = faultNum == 0 ? [] : rightList.slice(0, faultNum)

      this.alarm = alarmTotalCount
      this.fault = faultTotalCount
    },
  },
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;

  #lottie {
    // width: 180px;
  }

  .chartItem {
    width: 100%;
    height: 100%;

    .left-box, .right-box {
      width: 49%;
      height: 100%;
      display: inline-block;
      vertical-align: top;
      position: relative;
      .box-contain {
        width: 100%;
        position: absolute;
        top: 40%;
        left: 50%;
        margin-left: -70px;
        h4 {
          position: relative;
          top: -6px;
          color: #fff;
          width: 140px;
          font-size: 14px;
          color: #88B1D0;
          z-index: 9;
          font-weight: bold;
          .light-top {
            position: absolute;
            top: -18px;
            left: 14px;
            width: 110px;
          }
          .num {
            font-family: PMZD;
            color: #fff;
            font-size: 20px;
            margin-bottom: 4px;
            // text-shadow: .2rem 0rem .5rem red,-.2rem 0rem .5rem #fff;
          }
          .light-bottom {
            position: absolute;
            bottom: -15px;
            left: 14px;
            font-weight: normal;
            width: 110px;
            height: 30px;
            background: url('./../../assets/img/bigScreen/yd/demoa.png') no-repeat -20px -160px;
            background-size: 150px 187px;
          }
        }
        .di-tu {
          position: absolute;
          top: 0;
          left: 0;
          // border: 1px solid red;
          width: 140px;
          height: 78px;
          background: url('./../../assets/img/bigScreen/yd/demoa.png') no-repeat -15px 0px;
          background-size: 150px 187px;
        }
        .di-item {
          color: #fff;
          font-size: 12px;
          li {
            position: absolute;
            width: 20px;
            height: 15px;
            background: url('./../../assets/img/bigScreen/yd/demoa.png') no-repeat -15px 0px;
            background-size: 150px 187px;
            opacity: 0;
            // background-color: rgba(255,255,255, .1);
            // animation: fadeInOut 0.15s linear 2s 1 normal;
          }
        }
        .bottom {
          position: absolute;
          top: 37px;
          left: 7px;
          width: 125px;
        }
      }
    }
    .right-box {
      .box-contain {
        h4 {
          .light-bottom {
            background-image: url('./../../assets/img/bigScreen/yd/demob.png');
          }
        }
        .di-item {
          li {
            background-image: url('./../../assets/img/bigScreen/yd/demob.png');
          }
        }
      }
    }
  }

  @keyframes fadeInOut {
    0% { opacity: 0 }
    100% { opacity: 1 }
  }
  @mixin animation($delay){
    animation: fadeInOut 0.15s linear $delay 1 normal;
    animation-fill-mode: both;
  }
  @for $i from 1 through 26 {
    .li_#{$i - 1} {
      @include animation((($i + 1)*0.1)+s);
      // animation-fill-mode: forwords;
    }
  }
}
</style>
